var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2622 24.75V33.75M41.2622 20.25V29.25M39.0122 9C44.5218 9 47.5018 9.84321 48.9845 10.4972C49.1819 10.5843 49.2807 10.6279 49.5656 10.8998C49.7364 11.0628 50.0482 11.5411 50.1284 11.7632C50.2622 12.1337 50.2622 12.3362 50.2622 12.7412V36.9251C50.2622 38.9698 50.2622 39.9922 49.9556 40.5177C49.6437 41.0522 49.3429 41.3007 48.7591 41.5062C48.1852 41.7081 47.0266 41.4855 44.7096 41.0403C43.0878 40.7287 41.1644 40.5 39.0122 40.5C32.2622 40.5 25.5122 45 16.5122 45C11.0026 45 8.02266 44.1568 6.53994 43.5028C6.34248 43.4156 6.24375 43.3721 5.95881 43.1002C5.788 42.9372 5.47622 42.4589 5.39601 42.2368C5.26221 41.8663 5.26221 41.6638 5.26221 41.2588L5.26221 17.0749C5.26221 15.0302 5.26221 14.0078 5.56883 13.4823C5.88074 12.9478 6.18154 12.6993 6.76534 12.4938C7.33926 12.2919 8.49778 12.5145 10.8148 12.9597C12.4366 13.2713 14.36 13.5 16.5122 13.5C23.2622 13.5 30.0122 9 39.0122 9ZM33.3872 27C33.3872 30.1066 30.8688 32.625 27.7622 32.625C24.6556 32.625 22.1372 30.1066 22.1372 27C22.1372 23.8934 24.6556 21.375 27.7622 21.375C30.8688 21.375 33.3872 23.8934 33.3872 27Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollReports);
export default __webpack_public_path__ + "static/media/PayrollReports.cb7f6181f15bb67c2b684341b393c592.svg";
export { ForwardRef as ReactComponent };